<div class="banner">
  @if(this.showBanner == true){
    <marquee behavior="scroll" direction="left" scrollAmount="5" onmouseover="this.stop();" onmouseout="this.start();">
      {{movingText}}
    </marquee>
  }

  @if(this.showBannerPasswordReset == true) {
  <marquee behavior="scroll" direction="left" scrollAmount="5" onmouseover="this.stop();" onmouseout="this.start();">
    {{movingText}}
    <a href="link" target="_blank" style="color: 1283c6; text-decoration: underline; cursor: pointer; font-weight: lighter;"
      (click)="login('/dashboard')">click here</a>
  </marquee>
  }
</div>

